module.exports = __webpack_public_path__ + "static/media/c1bannerModul-e_small.dc1d4a03.jpg";